module.exports = __webpack_public_path__ + "media/images/doctor_congrats_2-c64accb79db94628dedb69ef47bb7491.jpg";